import React from "react";
import { IBaseBox } from "../../model/base";
import ItemPost from "./itemPost";

interface NewestPostsProps {
  posts: IBaseBox[];
  firstIndex?: boolean;
}

export default function NewestPosts(props: NewestPostsProps) {
  const { posts, firstIndex } = props;
  return posts ? (
    <>
      {posts.map((post, index) => (
        <ItemPost firstIndex={firstIndex && index === 0} key={index} post={post} />
      ))}
    </>
  ) : (
    <></>
  );
}
